// Angular Modules
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
// Operators
import { of, zip } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

// Services
import { EventsService } from '../services/events.service';
import { UserService } from '../services/user.service';

@Injectable()
export class HasAppointment implements CanActivate {
	constructor(
		protected events: EventsService,
		protected user: UserService,
		private router: Router
	) {}

	private goHome() {
		this.router.navigate(['/']).then();
	}

	canActivate(route: ActivatedRouteSnapshot) {
		const appointmentId = route.queryParamMap.get('appointmentId');
		const appointment$ = this.events.getEventInServer(appointmentId);
		const professional$ = this.user.getProfessionalProfileData();

		return zip(appointment$, professional$, (appointment, professional) => ({
			appointment,
			professional,
		})).pipe(
			map((pair) => {
				if (pair.appointment.status === 'cancelled') {
					this.goHome();
					return false;
				}

				if (pair.appointment.professionalId === pair.professional.id) {
					return true;
				}

				this.goHome();
				return false;
			}),
			catchError(() => {
				this.goHome();
				return of(false);
			})
		);
	}
}
